// extracted by mini-css-extract-plugin
module.exports = {"container":"container--PaymentMethodDropdown-components__1-6ed","dropdown":"dropdown--PaymentMethodDropdown-components__10GBs"};